import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { IconPhone } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useOpeningHours } from '../../../../../../components/hooks/useOpeningHours.js';
import { usePhoneNumber } from '../../../../../../components/hooks/usePhoneNumber.js';
import { Phone } from '../../../../../../components/internal/Phone.js';
import { Container } from '../../../../../../components/SearchForm/components/TravellersWidgetMultiroom/components/HotlineWidget/components/Container.js';
import { HeadlineSmall, LabelSmallSemibold, LabelXSmall, Stack } from '../../../../../../primitives/index.js';
import { qaId } from '../../../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../../../utils/qaId.js';
import { SPACING_SMALL, SPACING_XSMALL } from '../../../../../../utils/spacingLegacy.js';
export const HotlineWidget = ({
  serviceConfig,
  maxTravellersOrRoomsReached,
  multipleRooms
}) => {
  const {
    t
  } = useTranslation(['travellersWidgetMultiroom']);
  const phone = usePhoneNumber(maxTravellersOrRoomsReached || multipleRooms ? serviceConfig.multiRoomBooking : serviceConfig.phone);
  const {
    long
  } = useOpeningHours(serviceConfig);
  const openingHours = `${long.timeFrom} – ${long.timeUntil}`;
  const lgUp = useBreakpointUp('lg');
  const translationKey = maxTravellersOrRoomsReached ? 'maxReached' : multipleRooms ? 'multiRoomBooking' : 'roomBooking';
  return _jsxs(Container, {
    justifyContent: "center",
    alignItems: lgUp ? 'flex-start' : 'center',
    "data-testid": qaId(SEARCH_FORM_QA_ID, 'travelers-widget-hotLine'),
    children: [_jsx(HeadlineSmall, {
      textAlign: lgUp ? 'start' : 'center',
      "data-testid": qaId(SEARCH_FORM_QA_ID, 'travelers-widget-hotLine-header'),
      children: t(`hotline.${translationKey}.heading`)
    }), _jsxs(Stack, {
      spacing: lgUp ? SPACING_SMALL : SPACING_XSMALL,
      alignItems: lgUp ? 'flex-start' : 'center',
      children: [_jsx(LabelSmallSemibold, {
        style: {
          fontWeight: lgUp ? 400 : undefined
        },
        children: t(`hotline.${translationKey}.subHeading`)
      }), _jsxs(Phone, {
        href: `tel:${phone}`,
        "data-testid": qaId(SEARCH_FORM_QA_ID, 'travelers-widget-hotLine-phone-number'),
        children: [_jsx(IconPhone, {}), " ", phone]
      }), _jsx(LabelXSmall, {
        color: "contentSecondary",
        children: t('hotline.workingHours', {
          openingHours
        })
      })]
    })]
  });
};